import { all } from 'redux-saga/effects'
import analyticsSagas from './analytics'
import apiSagas from './api'
import appSagas from './appActions'
import assetSagas from './asset'
import buildersSagas from './builders'
import endpointSagas from './endpoint'
import folderSagas from './folder'
import formSubmissionsSagas from './formSubmissions'
import invitationSagas from './invitation'
import modalSagas, * as modalActions from './modal'
import notificationSagas from './notifications'
import permissionsSagas from './permissions'
import searchSagas from './search'
import settingsSagas from './settings'
import sharedEndpointSagas from './sharedEndpoints'
import superuserSagas from './superuser'
import userSagas from './user'

export default function* rootSaga() {
  try {
    yield all([
      apiSagas,
      appSagas,
      userSagas,
      assetSagas,
      modalSagas,
      folderSagas,
      formSubmissionsSagas,
      searchSagas,
      buildersSagas,
      endpointSagas,
      settingsSagas,
      sharedEndpointSagas,
      superuserSagas,
      analyticsSagas(), // This is a slightly different way of instantiating the saga.
      invitationSagas,
      permissionsSagas,
      notificationSagas,
    ])
  } catch (error) {
    modalActions.setMessage({
      type: 'ERROR',
      msg:
        'A problem occurred that caused BAM! to terminate. ' +
        'Please refresh your browser to restart',
    })
    modalActions.openModal('MessageModal')
  }
}
